import React from 'react';
import ThemePreloader from '../components/themes/ThemePreloader';
import { useSelector } from 'react-redux';

function AuthLayout({children}) {
    const showPreloader = useSelector(state => state.showPreloader);
    return (
        <>
            {showPreloader ? <ThemePreloader/> : null }
            <div style={{minHeight: '100vh', width: '100%', display: 'flex', flexDirection: 'column'}}>
                {children}
            </div>
        </>
    );
}

export default AuthLayout;